export default "__VITE_ASSET__DtwgYVTR__"